// extracted by mini-css-extract-plugin
export default {"appContainer":"Layout_appContainer__VtB61","mainContent":"Layout_mainContent__NyGQv"};